import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import { browserHistory } from 'react-router';
import { ConversationPane } from './elements/ConversationPane';
import { 
	getAllConversations,
	getConversation,
	sendMessage,
	} from '../../../../../actions/networking/networking';
import { Loader } from "../../../../common/elements";

class SingleConversation extends Component {

	componentDidMount() {

		const { getAllConversations, getConversation, params } = this.props;

		getAllConversations();
		getConversation( params.conversationId );
	};

	componentWillReceiveProps( nextProps ) {
		const { getConversation, params } = this.props,
			{ status } = nextProps;

		if( status && status !== 403 ) {
			browserHistory.push( '/networking/conversations' );
		}

		if ( params.conversationId !== nextProps.params.conversationId ) {
			getConversation( nextProps.params.conversationId );
		}

		//console.log(nextProps);

	};

	postMessage = ( message ) => {

		const { sendMessage, getConversation, params } = this.props,
      personId = localStorage.getItem('person_id');

		sendMessage( params.conversationId, message, personId );
		getConversation( params.conversationId );
	};

	render() {
		const { conversation, conversations } = this.props;
		let visible = false;
		const personId = localStorage.getItem('person_id');

		if (personId && conversation && conversation.messages && conversations && conversations.length > 0) {
			personId === conversation.creator_id ||
			conversation.messages.filter((message) => message.sender.id === personId).length > 0 ||
			conversations.filter((singleCon) => singleCon.id === conversation.id).length > 0
				? visible = true : browserHistory.push(`/networking/conversations`);
		}

		if( !conversation || !visible ) {
			return <Loader/>;
		}

		if ( visible ) {
			return (
				<ConversationPane
					conversation={ conversation } 
					postMessage={ ( message ) => this.postMessage( message ) }
				/>

			);
		}
	};
}

SingleConversation.propTypes = {
	conversation: PropTypes.oneOfType([
		PropTypes.object,
		PropTypes.bool
	]),
	conversations: PropTypes.array,
	myId: PropTypes.number,
	getAllConversations: PropTypes.func,
	getConversation: PropTypes.func,
	sendMessage: PropTypes.func
}


const mapStateToProps = ( state ) => {
	return {
		conversations: state.networking.conversations,
		conversation: state.networking.conversation,
		myId: state.profile.name.personId
	};
};

const mapDispatchToProps = ( dispatch ) => {
	return {
		getAllConversations: () => dispatch( getAllConversations() ),
		getConversation: ( conversationId ) => dispatch( getConversation( conversationId ) ),
		sendMessage: ( conversationId, message, personId ) => dispatch( sendMessage( conversationId, message, personId ) )
	};
};

export default connect( mapStateToProps, mapDispatchToProps )( SingleConversation );



// WEBPACK FOOTER //
// src/client/components/site/features/networking/pages/SingleConversation.js